import { useState, useEffect } from "react";
import Toast from "./Toast";
import Close from "./icons/Close";
import Share from "./icons/Share";
import { letterColors } from "../data/letters-list";

interface Props {
  data: any[];
  closeModal: boolean;
  gameResult: string;
  setCloseModal: React.Dispatch<React.SetStateAction<boolean>>;
  rightWord?: string;
}
const Modal = ({
  gameResult,
  data,
  closeModal,
  setCloseModal,
  rightWord,
}: Props) => {
  const [dsiplay, setDisplay] = useState<string>("hidden");
  const [toastData, setToastData] = useState<Array<any>>([]);
  const { letterAbsent, letterExist, letterRight } = letterColors;
  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    setCloseModal(true);
  };
  useEffect(() => {
    setTimeout(() => {
      setDisplay(closeModal ? "hidden" : "flex");
    }, 180);
  }, [closeModal]);

  const handleShare = () => {
    const guessPosition = gameResult === "win" ? `${data?.length}/6` : "0/6";
    const title = `خمسة بسبعة ${guessPosition}`;
    const clipBoard = data
      ?.map((wordColors: string[]) => {
        return wordColors
          .map((color: string) => {
            if (color === letterAbsent) return "⬜";
            else if (color === letterExist) return "🟨";
            return "🟩";
          })
          .join("");
      })
      .join("\n");
    navigator.clipboard
      .writeText(`${title}\n\n${clipBoard} `)
      .then(() => setToastData([...toastData, "نسخت !"]));
  };

  return (
    <>
      <div
        className={`${
          closeModal ? "hidden" : "flex"
        }  flex-nowrap justify-center items-center absolute p-0 m-0 top-0 right-0 bottom-0 w-full h-full bg-white/70 z-30`}
        onClick={handleClick}
      ></div>
      <div
        className={` z-50 absolute ${dsiplay} flex-col justify-center items-center w-2/3 h-auto py-5 bg-white drop-shadow-2xl p-3 ${
          closeModal ? " animate-slide-out" : "animate-slide-in"
        }`}
      >
        <div
          className="cursor-pointer self-start w-100 mb-7"
          onClick={handleClick}
        >
          <Close />
        </div>
        <div className="w-2/3 h-full flex flex-col justify-center items-center">
          <h1 className="text-xl font-bold">Congratulations! أحسنت!</h1>
          <div className="mt-5 w-full flex flex-col justify-center items-center">
            {gameResult !== "idle" ? (
              <div dir="ltr">
                <p>
                  {`You can check out the meaning of this word on `}
                  <a
                    href={`https://www.livingarabic.com/`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <strong>The Living Arabic Project</strong>
                  </a>
                  !
                </p>
                <p>
                  Don't forget to support The Living Arabic Project on{" "}
                  <a
                    href="https://www.patreon.com/livingarabic"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <strong>Patreon</strong>
                  </a>{" "}
                  if you want more cool games that work with dialects.
                </p>
              </div>
            ) : (
              <h2> لا توجد بيانات</h2>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
